import React, { useState, useEffect } from 'react';
import '../css/others/template.css';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { apiCall } from '../main/Apicall';
import Pagination from '../Reusablecomponents/Pagination';
import { EmailTemplate } from "../Interfaces/Interface"
const EmailTemplateUI: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const location = useLocation();
  const clientName = location.state?.clientName || '';
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<EmailTemplate[]>([]);
  const [, setIsLoading] = useState(false);
  const [, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  useEffect(() => {
    const fetchTemplates = async () => {
      if (!clientId) return;
      setIsLoading(true);
      setError(null);
      try {
        const data = await apiCall('get', `/api/email-templates?clientId=${clientId}&page=${currentPage - 1}&size=${itemsPerPage}`);
        setTemplates(data.content || []);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
      } catch (err: any) {
        console.error('Error fetching templates:', err);
      }
    };
    fetchTemplates();
  }, [clientId, currentPage, itemsPerPage]);
  const handleCreateNew = () => { navigate(`/createtemplate/${clientId}`); };
  const handleEdit = (template: EmailTemplate) => { navigate(`/emailtemplatedetail/${clientId}/${template.templateId}`); };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Email Templates - {clientName} ({clientId})</h2>
        <div className="table-title-actions">
          <button className="createnewtemplate" onClick={handleCreateNew} >Create New Template</button>
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>Template Name</th><th>Template Type</th>
              </tr>
            </thead>
            <tbody>
              {templates.length === 0 ? (
                <tr>
                  <td colSpan={2} className="no-data">No templates for this client ID.</td>
                </tr>
              ) : (
                templates.map((template) => (
                  <tr key={template.templateId}>
                    <td><span className="clickable" onClick={() => handleEdit(template)} title="Click to edit">{template.name}</span></td><td>{template.type}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalElements={totalElements}
        itemsPerPage={itemsPerPage}
        onPageChange={setCurrentPage}
        onItemsPerPageChange={setItemsPerPage}
      />
    </div>
  );
};
export default EmailTemplateUI;